import { APP, WS_DATA } from "./app.constants";

export const DEVICES = `${APP}_devices`;

export const SELECT_DEVICE = `${DEVICES}/SELECT_DEVICE`;
export const RESELECT_DEVICE = `${DEVICES}/RESELECT_DEVICE`;
export const SAVE_DEVICES = `${DEVICES}/SAVE_DEVICE`;
export const SEND_MESSAGE = `${DEVICES}/SEND_MESSAGE`;
export const SEND_COMMAND = `${DEVICES}/SEND_COMMAND`;
export const SEND_SMS = `${DEVICES}/SEND_SMS`;
export const REBOOT = `${DEVICES}/REBOOT`;
export const SEND_SERVER_CONFIG = `${DEVICES}/TRANSFER`;
export const REQUEST_LOCATION = `${DEVICES}/REQUEST_LOCATION`;
export const REQUEST_FIRMWARE = `${DEVICES}/REQUEST_FIRMWARE`;
export const TOGGLE_DEVCON = `${DEVICES}/TOGGLE_DEVCON`;
export const FORCE_SETTINGS = `${DEVICES}/FORCE_SETTINGS`;
export const PUSH_SETTING = `${DEVICES}/PUSH_SETTING`;
export const PUSH_SETTINGS = `${DEVICES}/PUSH_SETTINGS`;
export const MIGRATE_DEVICE_TO_V4 = `${DEVICES}/MIGRATE_DEVICE_TO_V4`;
export const CLEAR_RECEIVED_SETTINGS = `${DEVICES}/CLEAR_RECEIVED_SETTINGS`;
export const SHUT_DOWN = `${DEVICES}/SHUT_DOWN`;
export const FACTORY_RESTORE = `${DEVICES}/FACTORY_RESTORE`;
export const SET_TRACK_SINGLE_DEVICE_ID = `${DEVICES}/SET_TRACK_SINGLE_DEVICE_ID`;
export const CHECK_EMERIT_DEVICES_STATUS = `${DEVICES}/CHECK_EMERIT_DEVICES_STATUS`;
export const SET_EMERIT_V4_STATUSES = `${DEVICES}/SET_EMERIT_V4_STATUSES`;
export const SET_DEVICE_AVAILABILITY = `${DEVICES}/SET_DEVICE_AVAILABILITY`;
export const SET_DEVICE_ONLINE = `${DEVICES}/SET_DEVICE_ONLINE`;
// Re-read V4 device status from REST (see reconcileDeviceStatusSaga).
export const RECONCILE_DEVICE_STATUS = `${DEVICES}/RECONCILE_DEVICE_STATUS`;
export const RESYNC_V4_DEVICE_STATUSES = `${DEVICES}/RESYNC_V4_DEVICE_STATUSES`;
export const REFRESH_DEVICE_LOCATION = `${DEVICES}/REFRESH_DEVICE_LOCATION`;
export const SET_DEVICE_LOCATION = `${DEVICES}/SET_DEVICE_LOCATION`;
export const V4_DEVICE_SAVED = `${DEVICES}/V4_DEVICE_SAVED`;
// V4 websocket: a device config sync-run changed state (see V4AlarmWebSocket).
export const SYNC_RUN_EVENT = `${DEVICES}/SYNC_RUN_EVENT`;

export const FETCH_V4_ONLY_DEVICES = `${DEVICES}/FETCH_V4_ONLY_DEVICES`;
export const V4_ONLY_DEVICES_LOADED = `${DEVICES}/V4_ONLY_DEVICES_LOADED`;
// A V4 device's ARC link lives on the ARC (`device_links`), never on the device.
export const FETCH_V4_ARC_DEVICE_LINKS = `${DEVICES}/FETCH_V4_ARC_DEVICE_LINKS`;
export const V4_ARC_DEVICE_LINKS_LOADED = `${DEVICES}/V4_ARC_DEVICE_LINKS_LOADED`;
// One device's ARC link, checked when its DevCon opens.
export const CHECK_V4_ARC_DEVICE_LINK = `${DEVICES}/CHECK_V4_ARC_DEVICE_LINK`;
export const V4_ARC_DEVICE_LINK_CHECKED = `${DEVICES}/V4_ARC_DEVICE_LINK_CHECKED`;

export const WS_DATA_DEVICE = `${WS_DATA}/device`;
export const WS_DATA_DEVICE_PING = `${WS_DATA}/device/ping`;
export const WS_DATA_DEVICES = `${WS_DATA}/devices`;
export const WS_DATA_SETTING = `${WS_DATA}/setting`;
export const WS_DATA_IO = `${WS_DATA}/io`;
